<template>
    <div class="user">
        <div>
            <!--form表单-->
            <el-form size="small" ref="form" :model="form" label-width="200px">
                <div class="common-form">基本设置</div>
                <el-form-item label="VrID" prop="pano_id" :rules="[{required: true,message: '请输入VRID',trigger: 'blur'}]">
                    <el-input v-model.number="form.pano_id" class="max-w460"></el-input>
                    <div class="tips">前往VR后台获取</div>
                </el-form-item>

                <el-form-item label="VR地址" prop="vr_uri" :rules="[{required: true,message: '请输入VR地址',trigger: 'blur'}]">
                    <el-input v-model="form.vr_uri" class="max-w460"></el-input>
                    <div class="tips">前往VR后台获取</div>
                </el-form-item>

                <!--提交-->
                <div class="common-button-wrapper">
                    <el-button size="small" type="primary" @click="onSubmit" :loading="loading" v-auth="'/education/setting/index'">提交</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {vrDetail, steVr} from '@/api/education'

    export default {
        name: 'vr-setting',
        data() {
            return {
                /*form表单数据*/
                form: {
                    pano_id: '',
                    vr_uri: '',
                },
                /*是否正在加载*/
                loading: false,
            };
        },
        props: {},
        created() {
            this.getSet()
        },
        methods: {
            //提交表单
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid !== false) {
                        this.loading = true;
                        steVr(this.form)
                            .then(data => {
                                this.loading = false;
                                this.$message({
                                    message: '恭喜你，设置成功',
                                    type: 'success'
                                });
                            })
                            .catch(error => {
                                this.loading = false;
                            });
                    }
                })
            },

            // 获取配置
            getSet() {
                vrDetail().then((result) => {
                    if (result.data) {
                        console.log(result.data)
                        this.form.pano_id = result.data.pano_id;
                        this.form.vr_uri = result.data.vr_uri;
                    }
                    this.loading = false;
                })
            },
        }
    };
</script>

<style>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/vr/setting/index.vue